<template>
  <modal
    :show="show"
    footer-classes="justify-content-center"
    type="notice"
    @close="close"
  >
    <h5 slot="header" class="modal-title">Details</h5>
    <template>
      <slot />
    </template>
    <div slot="footer" class="justify-content-center d-flex">
      <p-button
        v-if="currentOperation === 'edit' || currentOperation === 'delete'"
        type="danger"
        round
        aria-label="Effacer"
        @click.native="$emit('delete')"
        >Effacer</p-button
      >
      <span v-if="currentOperation === 'edit' || currentOperation === 'delete'"
        >&nbsp;</span
      >
      <p-button
        v-if="currentOperation === 'edit'"
        type="success"
        round
        aria-label="Mettre à jour"
        @click.native="$emit('update')"
        >Mettre à jour</p-button
      >
      <span v-if="currentOperation === 'edit'">&nbsp;</span>
      <p-button
        v-if="currentOperation === 'create'"
        type="success"
        round
        aria-label="Créer"
        @click.native="$emit('create')"
        >Créer</p-button
      >
      <span v-if="currentOperation === 'create'">&nbsp;</span>
      <p-button
        type="light"
        round
        aria-label="Annuler"
        @click.native="$emit('cancel')"
        >Annuler</p-button
      >
    </div>
  </modal>
</template>

<script>
import { Modal } from 'src/components/UIComponents';

export default {
  name: 'DetailsModal',
  components: {
    Modal,
  },
  props: ['show', 'currentOperation'],
  methods: {
    close() {
      this.$emit('close');
    },
  },
};
</script>

<style>
.errorMessageInModal {
  margin: 10px 0;
  color: red;
}
</style>
